import React from "react";
import { FileDown } from "lucide-react";

export function OfficialReceiptMenu({ invioId, onDownload, compact = false }) {
    return (
        <button
            type="button"
            data-testid={`download-ricevuta-RC-${invioId}`}
            onClick={(event) => { event.stopPropagation(); onDownload(invioId, "RC"); }}
            className={`inline-flex items-center justify-center gap-1.5 rounded-md bg-primary text-xs font-bold text-white hover:bg-orange-600 ${compact ? "h-8 w-8 p-0" : "px-3 py-1.5"}`}
            title="Scarica la ricevuta completa"
            aria-label="Scarica la ricevuta completa"
        >
            <FileDown size={compact ? 16 : 13} /> {!compact && "Ricevuta"}
        </button>
    );
}
